<!--
 * @Author: your name
 * @Date: 2020-07-23 16:20:22
 * @LastEditTime: 2021-01-14 11:06:00
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\App.vue
-->
<template>
  <div id="app">
    <keep-alive :include="include">
      <router-view />
    </keep-alive>
    <template>
      <x-modal title :visible.sync="visible">
        <div class="version-modal-icon-box">
          <x-svg-icon name="version-due"></x-svg-icon>
          <p class="title-up">
            {{ $t('common.versionOverdueTitle') }}
          </p>
          <p class="title-down">
            {{ $t('common.versionOverdueMsg') }}
          </p>
        </div>
      </x-modal>
    </template>
    <template>
      <x-modal
        title="扫一扫"
        :visible.sync="globalScanModal.visible"
        class="scan-qrcode-modal"
        @close="handleScanModalClose"
      >
        <div class="scan-qrcode-modal-content">
          <div class="scan-area">
            <div class="top-mask"></div>
            <div class="mark top-left"></div>
            <div class="mark top-right"></div>
            <div class="mark bottom-left"></div>
            <div class="mark bottom-right"></div>
          </div>
          <video ref="camera" autoplay width="250px" height="250px"></video>
          <canvas ref="canvas" width="250px" height="250px"></canvas>
        </div>
      </x-modal>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import { SET_USER_INFO, SET_TOKEN } from '@/store/auth.store.js'
import { SET_CURRENT_DEPARTMENT } from '@/store/tenant.store.js'
import { mapMutations, mapState } from 'vuex'
import apis from '@/api'
import { SET_OPEN_ID, SET_UNION_ID } from './store/oauth.store'
import { RuleEngine, Assert } from '@x-apaas/x-lib-rule-engine'
import { wxSdkInit } from '@/vender/third-sdk/wx-sdk.js'
import { feishuSdkInit } from '@/vender/third-sdk/feishu-sdk.js'
import { dingdingSdkInit } from '@/vender/third-sdk/dingding-sdk.js'
import { isWechat, isOnlyWechat, isIos, isPhone, isFeishu, isDingding } from '@/lib/ui/utils/platform.util.js'
import QrCode from 'qrcode-reader'

export default {
  data() {
    return {
      keepAliveComps: {},
      visible: false,
      globalScanModal: {
        visible: false,
        videoObj: null,
        getimgsetInterval: null
      },
      scanModalOpt: {
        showGlobalScanModal: (callback) => {
          this.globalScanModal.visible = true
          this.$nextTick(() => {
            this.scanQrCode((result) => {
              if (result) {
                callback(result)
              } else {
                Vue.prototype.$message({
                  type: 'error',
                  message: `浏览器不支持扫码`
                })
                this.globalScanModal.visible = false
                this.handleScanModalClose()
                callback()
              }
            })
          })
        },
        dismissGlobalModal: () => {
          this.globalScanModal.visible = false
          this.handleScanModalClose()
        }
      }
    }
  },
  provide() {
    return {
      addKeepAlive: this.addKeepAlive,
      removeKeepAlive: this.removeKeepAlive
    }
  },
  computed: {
    ...mapState({
      token: (state) => state.authModule.token,
      currentOrg: (state) => state.tenantModule.currentOrg,
      userInfo: (state) => state.authModule.userInfo,
      department: (state) => state.tenantModule.department,
      roleList: (state) => state.themeModule.roleList
    }),
    include() {
      console.log('include', Object.keys(this.keepAliveComps))
      return Object.keys(this.keepAliveComps)
    }
  },
  created() {
    Vue.prototype.$showVersionOverdue = this.showVersionOverdue
    Vue.prototype.$scanModalOptEvent = this.scanModalOpt // 扫码弹窗opt
    Vue.prototype.$globalScanModal = this.globalScanModal // 扫码弹窗状态
    // Vue.prototype.$deviceInfo = null // 设备信息
    // 微信初始化
    this.wxInit()
    // 飞书初始化
    this.feishuInit()
    // 钉钉初始化
    this.dingdingInit()
    this.registerFormContextMethod()
  },
  mounted() {
    this.$nextTick(() => {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      // 如果是IOS设备
      if (isiOS) {
        let flag = false
        let pageBackNormFunc
        // 聚焦后，键盘弹起
        document.body.addEventListener('focusin', () => {
          flag = true
          pageBackNormFunc && clearTimeout(pageBackNormFunc)
        })
        // 失焦后，键盘关闭
        document.body.addEventListener('focusout', () => {
          if (flag) {
            // 页面滚动回原来的位置
            pageBackNormFunc = setTimeout(() => {
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
            }, 200)
          }
          flag = false
        })
      }
    })
  },
  methods: {
    ...mapMutations('authModule', {
      setUserInfo: SET_USER_INFO,
      setToken: SET_TOKEN
    }),
    ...mapMutations('tenantModule', {
      setCurrentDepartment: SET_CURRENT_DEPARTMENT
    }),
    ...mapMutations('oauthModule', {
      setOpenId: SET_OPEN_ID,
      setUnionId: SET_UNION_ID
    }),
    wxInit() {
      if (isWechat() && isIos()) {
        // 微信ios焦点bugfix
        this.weiWebInit()
      }
      if (isOnlyWechat()) {
        // 微信sdk初始化
        wxSdkInit()
        // 判断是否可以进行微信登陆
        if (this.$route.query.code) {
          console.log('wechat login')
          this.$loading.show()
          const getOpenIdRequest = { ...apis.ACCOUNT.GET_OPENID_BY_CODE }
          getOpenIdRequest.params = {
            code: this.$route.query.code
          }
          this.$request(getOpenIdRequest)
            .asyncThen(
              (resp) => {
                this.setOpenId(resp.data.openId)
                this.setUnionId(resp.data.unionId)

                const loginByCodeRequest = { ...apis.ACCOUNT.LOGIN_BY_CODE }
                loginByCodeRequest.params = {
                  unionId: resp.data.unionId,
                  type: 'WXCODE'
                }
                this.$request(loginByCodeRequest, false)
                  .asyncThen(
                    (res) => {
                      this.$loading.hide()
                      this.setToken(res.data.token)
                      this.setUserInfo(res.data.user)
                      this.setCurrentDepartment(res.data.userDepartment)
                      if (res.data.tenantId) {
                        this.$router.replace({
                          name: 'workbench',
                          params: { orgId: res.data.tenantId }
                        })
                      } else {
                        this.$router.replace({
                          name: 'org-setting'
                        })
                      }
                    },
                    (err) => {
                      console.error(err)
                      this.$loading.hide()
                      this.$router.replace({ name: 'account' })
                    }
                  )
                  .asyncErrorCatch((err) => {
                    this.$loading.hide()
                    console.error(err)
                    this.$router.replace({ name: 'account' })
                  })
              },
              (err) => {
                console.error(err)
                this.$loading.hide()
                this.$router.replace({ name: 'account' })
              }
            )
            .asyncErrorCatch((err) => {
              console.error(err)
              this.$loading.hide()
              this.$router.replace({ name: 'account' })
            })
        }
      }
    },
    feishuInit() {
      if (isFeishu()) {
        feishuSdkInit()
      }
    },
    dingdingInit() {
      if (isDingding()) {
        dingdingSdkInit()
      }
    },
    showVersionOverdue() {
      this.visible = true
    },
    addKeepAlive(compName) {
      this.$set(this.keepAliveComps, compName, true)
    },
    removeKeepAlive(compName) {
      this.$delete(this.keepAliveComps, compName)
    },
    weiWebInit() {
      let myFunction
      // 既是微信浏览器 又是ios============（因为查到只有在微信环境下，ios手机上才会出现input失去焦点的时候页面被顶起）
      document.body.addEventListener('focusin', () => {
        // 软键盘弹起事件
        clearTimeout(myFunction)
      })
      document.body.addEventListener('focusout', () => {
        // 软键盘关闭事件
        clearTimeout(myFunction)
        myFunction = setTimeout(function() {
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }) // 重点  =======当键盘收起的时候让页面回到原始位置
        }, 200)
      })
    },
    // isWeiXinAndIos() {
    //   // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    //   let ua = '' + window.navigator.userAgent.toLowerCase()
    //   // 通过正则表达式匹配ua中是否含有MicroMessenger字符串且是IOS系统
    //   let isWeixin = /MicroMessenger/i.test(ua) // 是在微信浏览器
    //   let isIos = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua) // 是IOS系统
    //   return isWeixin && isIos
    // },
    registerFormContextMethod() {
      const getDeptValueFunction = {
        name: 'xdapcuruserdeptvalue',
        needComponentConfig: true,
        needYield: true,
        mockFunction: (...args) => {
          Assert.argsLength(args, 0)
        },
        executeFunction: (...args) => {
          Assert.argsLength(args, 0)
          if (!this.department) {
            return []
          } else if (Array.isArray(this.department)) {
            return this.department.map((item) => item.id)
          } else {
            return [this.department.id]
          }
        }
      }
      RuleEngine.getInstance().registerContextMethod(
        getDeptValueFunction.name,
        getDeptValueFunction
      )
      const getCurrentUserFunction = {
        name: 'xdapcuruservalue',
        needComponentConfig: true,
        needYield: true,
        mockFunction: (...args) => {
          Assert.argsLength(args, 0)
        },
        executeFunction: (...args) => {
          Assert.argsLength(args, 0)
          if (!this.userInfo) {
            return ''
          } else {
            return this.userInfo.id
          }
        }
      }
      RuleEngine.getInstance().registerContextMethod(getCurrentUserFunction.name, getCurrentUserFunction)

      const getRoleValueFunction = {
        name: 'xdapcuruserrolevalue',
        needComponentConfig: true,
        needYield: true,
        mockFunction: (...args) => {
          Assert.argsLength(args, 0)
        },
        executeFunction: (...args) => {
          Assert.argsLength(args, 0)
          if (!this.roleList) {
            return []
          } else {
            return this.roleList.map((item) => item.id)
          }
        }
      }
      RuleEngine.getInstance().registerContextMethod(
        getRoleValueFunction.name,
        getRoleValueFunction
      )
    },
    // 调用摄像头扫码，callback为扫描结果
    scanQrCode(callback) {
      // 方法部分--开启摄像头
      let constraints = {
        audio: false,
        video: {
          width: 250,
          height: 250
        }
      }
      if (isPhone()) {
        constraints.video.facingMode = {
          exact: 'environment' // 后置摄像头
        }
      }
      // if (Vue.prototype.$deviceInfo && Vue.prototype.$deviceInfo.length > 0) {
      //   const deviceList = Vue.prototype.$deviceInfo.filter(item => item.kind === 'videoinput')
      //   if (deviceList.length > 0) {
      //     constraints.video.deviceId = {
      //       exact: deviceList[deviceList.length - 1].deviceId
      //     }
      //   }
      // }
      let video = this.$refs.camera
      let canvas = this.$refs.canvas
      let Context = canvas.getContext('2d')
      console.log(navigator)
      let promise = null
      // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
      // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia

          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
          }

          // 否则，为老的navigator.getUserMedia方法包裹一个Promise
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      promise = navigator.mediaDevices.getUserMedia(constraints)
      promise
        .then(
          (mediaStream) => {
            this.globalScanModal.videoObj = mediaStream.getTracks()
            try {
              if ('srcObject' in video) {
                video.srcObject = mediaStream
              } else {
                // 防止在新的浏览器里使用它，应为它已经不再支持了
                video.src = window.URL.createObjectURL(mediaStream)
              }
              // 每过1秒获取一次图片
              let qr = new QrCode()
              qr.callback = function(err, value) {
                if (err) {
                  console.log('识别中')
                } else {
                  Vue.prototype.$scanModalOptEvent.dismissGlobalModal()
                  callback({
                    result: value.result
                  })
                }
              }
              this.globalScanModal.getimgsetInterval = setInterval(() => {
                Context.drawImage(video, 0, 0)
                // let imgurl = canvas.toDataURL('image/png')
                let imgurl = Context.getImageData(0, 0, 250, 250)
                qr.decode(imgurl)
              }, 1000)
            } catch (error) {
              console.log(error)
              callback()
            }
            video.play()
          },
          (error) => {
            console.log(error)
            callback()
          }
        )
        .catch((err) => {
          console.log(err)
          callback()
        })
    },
    // 关闭扫码弹窗
    handleScanModalClose() {
      // 停止使用摄像头
      this.globalScanModal.videoObj &&
        this.globalScanModal.videoObj[0] &&
        this.globalScanModal.videoObj[0].stop()
      // 关闭定时器
      clearInterval(this.globalScanModal.getimgsetInterval)
    }
  }
}
</script>

<style lang="scss">
.version-modal-icon-box {
  margin-top: 0.714rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  .svg-icon {
    width: 8.571rem !important;
    height: 8.571rem !important;
  }
  .title-up {
    margin-top: 1.714rem;
    font-size: $--app-title-font-size;
  }
  .title-down {
    margin-top: 0.857rem;
    margin-bottom: 1.714rem;
    font-size: $--app-title-font-size;
  }
}
.scan-qrcode-modal {
  &.x-modal {
    .x-modal-main {
      height: 100vh;
      width: 100vw;
      margin: 0;
      .x-modal-content {
        height: 100vh;
        width: 100vw;
        padding: 0;
        max-height: 100vh;
        background-color: #000;
        .x-modal-header {
          padding: 3.14rem 0;
          color: #fff;
          position: absolute;
          width: 100%;
          text-align: center;
          z-index: 103;
        }
        .x-modal-body {
          height: 100%;
          width: 100%;
          .scan-qrcode-modal-content {
            height: 100%;
            width: 100%;
            .scan-area {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
              height: 250px;
              width: 250px;
              z-index: 101;
              border: 1px solid #fff;
              &::after {
                content: ' ';
                width: 100%;
                display: block;
                height: 125px;
                position: absolute;
                animation: move 3s linear infinite;
                background: linear-gradient(
                  180deg,
                  rgba(76, 175, 80, 0) 50%,
                  rgba(76, 175, 80, 1) 200%
                );
                border-bottom: 2px solid rgba(76, 175, 80, 1);
              }
              @keyframes move {
                // from { top: 0px; }
                // to { top: 230px; }
                0% {
                  transform: translateY(-100%);
                }
                100% {
                  transform: translateY(100%);
                }
              }
              .top-mask {
                position: absolute;
                height: 125px;
                width: 100%;
                top: -126px;
                background: #000;
                z-index: 102;
              }
              .mark {
                position: absolute;
                width: 20px;
                height: 20px;
                border: 3px solid #4caf50;
                background: transparent;
                &.top-left {
                  top: -1px;
                  left: -1px;
                  border-color: #4caf50 transparent transparent #4caf50;
                }
                &.top-right {
                  top: -1px;
                  right: -1px;
                  border-color: #4caf50 #4caf50 transparent transparent;
                }
                &.bottom-left {
                  bottom: -1px;
                  left: -1px;
                  border-color: transparent transparent #4caf50 #4caf50;
                }
                &.bottom-right {
                  bottom: -1px;
                  right: -1px;
                  border-color: transparent #4caf50 #4caf50 transparent;
                }
              }
            }
            > video {
              position: absolute;
              z-index: 100;
              margin: auto;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
            }
            > canvas {
              position: absolute;
              margin: auto;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
            }
          }
        }
      }
      .x-modal--close {
        position: absolute;
        top: calc(50vh + 13rem);
        width: 100%;
        margin: auto;
        right: 0;
        left: 0;
      }
    }
  }
}
</style>
